var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "legal-agreement" }, [
    _c("div", { staticClass: "terms-box" }, [
      _c("h4", { staticClass: "terms-heading" }, [
        _vm._v("Terms & Conditions")
      ]),
      _vm._v(" "),
      _c("div", { ref: "termsScroll", staticClass: "terms-scroll" }, [
        _c(
          "ol",
          { staticClass: "terms-list" },
          _vm._l(_vm.termsItems, function(item, index) {
            return _c(
              "li",
              { key: index },
              [
                typeof item === "string"
                  ? [_vm._v(_vm._s(item))]
                  : [
                      _vm._v(
                        "\n            " + _vm._s(item.text) + "\n            "
                      ),
                      item.subItems && item.subItems.length
                        ? _c(
                            "ul",
                            { staticClass: "terms-sublist" },
                            _vm._l(item.subItems, function(sub, subIndex) {
                              return _c("li", { key: subIndex }, [
                                _vm._v(_vm._s(sub))
                              ])
                            }),
                            0
                          )
                        : _vm._e()
                    ]
              ],
              2
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "terms-confirm", class: { "has-error": _vm.termsError } },
      [
        _c("input", {
          staticClass: "terms-confirm-input",
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.termsAccepted },
          on: {
            change: function($event) {
              return _vm.onTermsChange($event.target.checked)
            }
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "terms-confirm-text" }, [
          _vm._v(_vm._s(_vm.$t("termsConfirm")) + " "),
          _c("span", { staticClass: "req" }, [_vm._v("*")])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.termsError
      ? _c("p", { staticClass: "field-error" }, [
          _vm._v(_vm._s(_vm.termsError))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "signature-section" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "canvas-wrap", class: { empty: _vm.isEmpty() } },
        [_c("canvas", { ref: "canvas" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sig-actions" }, [
        _c(
          "button",
          {
            staticClass: "btn-clear",
            attrs: { type: "button" },
            on: { click: _vm.clear }
          },
          [_vm._v("Clear")]
        ),
        _vm._v(" "),
        !_vm.hasSig
          ? _c("span", { staticClass: "sig-hint" }, [
              _vm._v("Please sign above to agree")
            ])
          : _c("span", { staticClass: "sig-ok" }, [
              _vm._v("Signature captured")
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("Signature "),
      _c("span", { staticClass: "req" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1712e5fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1712e5fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegalAgreement.vue
// module id = 435
// module chunks = 0